module.exports = __webpack_public_path__ + "img/SysComm3.9b643d12.png";